import apiFetch from '@/api/apiFetch';
import { t } from '@/translations/i18n';
import { DTOToProduct, productToDTO } from '@/typescript/transformers/product';
import type { IProduct } from '@/typescript/interfaces/IProduct';
import type { IProductDTO } from '@/typescript/interfaces/IProductDTO';

async function getProducts(): Promise<IProduct[]> {
    const response = await apiFetch('/templates/');
    if (!response.ok) {
        throw new Error(t('fetch_products_error'));
    }

    const productsDTO = (await response.json()) as IProductDTO[];

    return productsDTO.map((dto) => DTOToProduct(dto));
}

async function putProduct(product: IProduct) {
    const productDTO = productToDTO(product);
    const body = {
        projectJson: productDTO.projectJson,
    };
    const response = await apiFetch(`/templates/${product.id}/`, {
        method: 'PUT',
        body: JSON.stringify(body),
    });
    if (!response.ok) {
        throw new Error(t('save_product_error'));
    }
}

export { getProducts, putProduct };
